const home = {
  path: 'home',
  component: resolve => require(['../../../../pages/admin/home'], resolve),
  meta: {
    requireAuth: true
  }
}

export default home
